import { Navigate, useLocation } from 'react-router';
import { CircularProgress, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from './useAuth';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { account, user, loading } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!account) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Authentifié Entra mais pas de doc Firestore → provisioning manquant (spec §7.2).
  if (!user) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', gap: 2, p: 4, textAlign: 'center' }}>
        <Typography variant="h6">{t('auth.notProvisioned')}</Typography>
        <Typography color="text.secondary">{t('auth.notProvisionedBody')}</Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
